import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const ChannelContent = ({data}) => {

    useEffect(() => {
        const values = [];
        const labels = [];

        data.attendanceByChannels?.sort((a, b) => b.qty - a.qty).forEach((item) => {
            item.channel === 'SOS' ? labels.push(item.channel) : labels.push(ReportUtils.formatText(item.channel));
            values.push(item.qty);
        });

        ReportUtils.createExportableTable(labels, values, "Atendimentos por canal");
        GraphicUtils.barChart('attendance-by-channels', values.slice(0, 15), labels.slice(0, 15), false);
    }, [data]);

    return (
        <>
            <div className="chart-report">
                <div className="chart-title mb-3">Atendimentos por canal {data.attendanceByChannels.length >= 15 ? ' (TOP 15)' : ''}</div>
                <div className="chart-report bar-chart" id="attendance-by-channels"></div>
            </div>
        </>
    );
};

export default ChannelContent;